import { render, staticRenderFns } from "./Problem.vue?vue&type=template&id=f3b1f00c&scoped=true&"
import script from "./Problem.vue?vue&type=script&lang=js&"
export * from "./Problem.vue?vue&type=script&lang=js&"
import style0 from "./Problem.vue?vue&type=style&index=0&id=f3b1f00c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b1f00c",
  null
  
)

export default component.exports